import { useEffect, useState, Suspense } from 'react'

import { modalRegistry, ModalTypes } from '../registry'

export const ModalRenderer = ({ type }: { type?: ModalTypes }) => {
    const [Component, setComponent] = useState<React.ComponentType | null>(null)

    useEffect(() => {
        if (!type) {
            setComponent(null)
            return
        }

        setComponent(() => modalRegistry[type])
    }, [type])

    if (!Component) {
        return null
    }

    return (
        <Suspense fallback={null}>
            <Component />
        </Suspense>
    )
}
